import { api } from '$app/api';

/**
 * For both add and remove {
      "associationId":"5c47d91e-9223-4e20-8f9b-fb5a148d5c34",
      "specialityId": "dd9ebddb-bedc-48d7-8465-cf38af341244",
      "specialityOwnerId": "dd9ebddb-bedc-48d7-8465-cf38af347fcb"
    }]
 */

export function updateSpecialityAssociations({remove, add}) {
  return api.post(`/speciality`, {
    "eventType": "UpdateSpecialityAssociationsRequest",
    "body": { remove, add }
  })
  .then(res => res.data);
}

export function getSpecialitiesByOwner(garageId) {
  return api.post(`/speciality`, {
    "eventType":"GetSpecialityByOwnersRequest",
    "body":{
        "ids": [
          { "id": garageId }
        ]
    }
  })
  .then(res => res.data);
}

export function listSpecialities() {
  return api.post(`/speciality`, {
    "eventType": "ListSpecialitiesRequest",
    "body": {}
  })
  .then(res => res.data);
}
